module.exports = __webpack_public_path__ + "static/media/home2.3b6da439.png";